import { Avatar } from "@mui/material";
import { BAKER_PIC_FOLDER, STORAGE_BUCKET } from "./constants";

export default function DSPLogo(props) {
  const { provider, size, siteId } = props;
  return (
    <Avatar
      style={{ width: size || "32px", height: size || "32px", justifyContent: "center" }}
      src={
        !provider?.name || provider.name === "in-house"
          ? `${BAKER_PIC_FOLDER}/${siteId}/logo400.webp`
          : `${STORAGE_BUCKET}/img/logo/${provider.name.toLowerCase()}.webp`
      }
    ></Avatar>
  );
}
